import type { Location } from '@atlassian/react-resource-router';

export function getBoardSettingsHref(view: string, location: Location) {
	if (!isServiceDeskLocation(location)) {
		const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
		const query = location.search ? location.search : '';
		return `${basePath}/${view}${query}`;
	}
	return `${location.pathname}?config=${view}`;
}

export function isSelected(view: string, _ = '', pathConfig = '') {
	return pathConfig === view;
}

export function getBoardUrl(projectKey: string, boardId: string, isCMPBoard: boolean) {
	return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}

export function getJSMBoardUrl(projectKey: string, boardId: string) {
	return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}

export function getJSMCalendarUrl(projectKey: string, boardId: string) {
	return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}

export function getUserBoardUrl(accountId: string, boardId: string) {
	return `/jira/people/${accountId}/boards/${boardId}`;
}

export function getBoardSettingsUrl(ordinaryBoardUrl: string) {
	return `${ordinaryBoardUrl}/settings`;
}

function isServiceDeskLocation(location: Location) {
	return location.pathname.includes('/servicedesk');
}
